// extracted by mini-css-extract-plugin
export default {"App":"App_App__aD+9a","hw":"App_hw__FZFw+","hwTitle":"App_hwTitle__GCB72","hw10":"App_hw10__XzAYd"};